/** Where the landing's CTAs send users. */
export const APP_URL = 'https://app.routenroute.com'
